import { AppContext } from 'next/app';
import requestIp from 'request-ip';
import { IParsedAppContext } from 'base/utils/parse-app-context';
import { ILocaleList, ILocale } from 'mod/store/locale/interface';
import { getIPLocale } from 'mod/store/locale/service';
import { defaultLocale, getValidLocale } from 'mod/store/locale/utils';

export type RootStateType = IParsedAppContext & {
    pageLoading: boolean; // 是否页面跳转中
    useRem: boolean; //手机端是否使用rem
}

export type RootStoreType = {
    state: RootStateType;
    update: (newState: Partial<RootStateType>) => void;//更新state
    fetchLocaleInfo: (appContext: AppContext, localeList: ILocaleList) => Promise<void>;//获取ip对应的国家和货币
    fetchIPLocale: (appContext: AppContext) => Promise<void>;//获取ip对应的国家
    updateAfterRouterChange: (newState: RootStateType) => void;//router变化后更新rootStore
}

const createRootStore = (rootState: IParsedAppContext): RootStoreType => {
    return {
        state: {
            ...rootState,
            pageLoading: false,
            useRem: true,
        },
        update(newState) {
            for (const key in newState) {
                const storeKey = key as keyof RootStateType;
                // @ts-ignore
                this.state[storeKey] = newState[storeKey];
            }
        },
        updateAfterRouterChange(newState) {
            // ua是对象，引用地址变更会导致组件重新渲染
            const { ua } = this.state;
            const { pageLoading, ...rest } = newState;
            this.update({ ...rest, ua });
        },
        async fetchLocaleInfo({ ctx }, localeList) {
            let { country, currency, lang } = this.state;
            let locale: ILocale;
            if (!country) {
                const ip = requestIp.getClientIp(ctx.req);
                locale = await getIPLocale(ip).catch(() => defaultLocale);
                // const { country = 'US', currency = 'USD', lang = 'en' } = res || {};
            } else {
                locale = getValidLocale(localeList, { country, currency, lang });
            }
            this.update(locale);
        },
        async fetchIPLocale({ ctx }) {
            let { country, currency, lang } = this.state;
            let locale: ILocale;
            if (!country || !currency || !lang) {
                const ip = requestIp.getClientIp(ctx.req);
                locale = await getIPLocale(ip).catch(() => defaultLocale);
                this.update(locale);
            }
        },
    }
};

export default createRootStore;